import { apiClient } from './authService';
const base = '/reporting/v1/admin';
const reportingApiService = {
  getSettings: async () => (await apiClient.get(`${base}/settings/`)).data,
  saveSettings: async (values) => (await apiClient.patch(`${base}/settings/`, values)).data,
  rotateKey: async () => (await apiClient.post(`${base}/rotate-key/`, {})).data,
};
export default reportingApiService;
